import { appDownloadCta } from '@/mocks/home';

const appPreviews = [
  {
    imageUrl: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20entertainment%20news%20app%20interface%20with%20trending%20gossip%20articles%20in%20Chinese%2C%20warm%20amber%20and%20dark%20theme%20design%2C%20modern%20mobile%20UI%20with%20card%20layout%2C%20cinematic%20app%20screenshot%2C%20clean%20minimal%20design%2C%20editorial%20news%20app%20aesthetic%2C%20premium%20feel%20with%20soft%20shadows&width=400&height=800&seq=app-preview-1&orientation=portrait",
  },
  {
    imageUrl: "https://readdy.ai/api/search-image?query=Smartphone%20showing%20video%20playback%20screen%20with%20entertainment%20gossip%20content%2C%20dark%20theme%20media%20player%20interface%2C%20warm%20amber%20accent%20colors%2C%20modern%20mobile%20app%20design%2C%20cinematic%20video%20player%20UI%2C%20elegant%20minimal%20layout%2C%20premium%20streaming%20app%20aesthetic&width=400&height=800&seq=app-preview-2&orientation=portrait",
  },
  {
    imageUrl: "https://readdy.ai/api/search-image?query=Smartphone%20displaying%20social%20media%20feed%20style%20news%20app%20with%20celebrity%20gossip%20headlines%20in%20Chinese%2C%20dark%20warm%20toned%20interface%2C%20card%20based%20layout%2C%20modern%20editorial%20app%20design%2C%20clean%20sophisticated%20mobile%20UI%2C%20premium%20content%20discovery%20aesthetic&width=400&height=800&seq=app-preview-3&orientation=portrait",
  },
  {
    imageUrl: "https://readdy.ai/api/search-image?query=Smartphone%20showing%20notification%20screen%20with%20breaking%20entertainment%20news%20alerts%20in%20Chinese%2C%20dark%20warm%20theme%2C%20push%20notification%20cards%2C%20modern%20mobile%20app%2C%20clean%20notification%20center%20design%2C%20premium%20editorial%20alert%20aesthetic&width=400&height=800&seq=app-preview-4&orientation=portrait",
  },
];

export default function AppDownloadCta() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-tight">
          {appDownloadCta.title}
        </h2>
        <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-md mx-auto">
          {appDownloadCta.subtitle}
        </p>
        <button className="mt-8 inline-flex items-center gap-2 px-8 py-4 text-sm font-semibold text-background-50 bg-secondary-600 rounded-full hover:bg-secondary-700 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-secondary-600/20">
          {appDownloadCta.buttonLabel}
          <i className="ri-arrow-right-line"></i>
        </button>

        <div className="mt-10 relative">
          <div className="flex items-center justify-center gap-2 md:gap-4 flex-wrap">
            {appPreviews.map((img, i) => (
              <div
                key={i}
                className="w-32 md:w-40 h-64 md:h-80 rounded-2xl overflow-hidden bg-background-100 flex-shrink-0"
              >
                <img
                  src={img.imageUrl}
                  alt={`51吃瓜APP预览 ${i + 1}`}
                  title="51吃瓜APP下载"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            ))}
          </div>
        </div>

        <p className="mt-8 text-xs text-foreground-400">
          支持 iOS / Android · 已通过安全检测 · 纯净无广告
        </p>
      </div>
    </section>
  );
}